export default {
  username: '',
  password: '',
  loginUsing: '',
  overrideExistingToken: false,
  rememberMe: true,
  mfa: '',
};
